module.exports = __webpack_public_path__ + "static/media/pl_logo.885f355c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/performanceLeader/pl_logo.svg
// module id = 222
// module chunks = 0